import * as React from 'react';
const SvgSpotify = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        width={20}
        height={20}
        fill='none'
        {...props}>
        <g clipPath='url(#a)'>
            <path
                fill='currentColor'
                d='M9.798 2.006a7.5 7.5 0 1 0-.595 14.988 7.5 7.5 0 0 0 .595-14.988m3.165 10.987a.447.447 0 0 1-.61.168 9 9 0 0 0-3.212-1.092 9 9 0 0 0-3.387.164.448.448 0 1 1-.211-.87 9.9 9.9 0 0 1 3.723-.181 9.9 9.9 0 0 1 3.53 1.2c.215.123.29.395.168.61m.986-1.97a.583.583 0 0 1-.789.236 11 11 0 0 0-3.733-1.224 11 11 0 0 0-3.925.148.583.583 0 1 1-.25-1.137A12.2 12.2 0 0 1 9.59 8.88c1.454.204 2.842.66 4.124 1.353a.58.58 0 0 1 .235.79m1.093-2.218a.717.717 0 0 1-.967.305 13.4 13.4 0 0 0-4.323-1.38 13.4 13.4 0 0 0-4.537.135.716.716 0 0 1-.285-1.404 14.8 14.8 0 0 1 5.021-.15c1.68.237 3.29.75 4.786 1.529a.716.716 0 0 1 .305.966z'
            />
        </g>
        <defs>
            <clipPath id='a'>
                <path fill='#fff' d='M2 2h15v15H2z' />
            </clipPath>
        </defs>
    </svg>
);
export default SvgSpotify;
